<template>
  <b-form-group
    :label="$t('tasks.form.title')"
    label-for="title"
  >
    <validation-provider
      #default="{ errors }"
      :name="$t('tasks.form.title')"
      rules="required|min:3"
    >
      <b-form-input
        id="title"
        v-model="dataItem.title"
        :placeholder="$t('tasks.form.titlePlaceholder')"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'TasksTitleCard',
  components: { BFormGroup, BFormInput, ValidationProvider },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['tasks/dataItem']
    },
  },
}
</script>
